import Preset from './_default';

export default class Brooklyn extends Preset {
    name = 'Supply';

    // override the default Preset here
}
